import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../fragments'

const CUISINE_TYPES_QUERY = gql`
  query cuisineTypes {
    cuisineTypes {
      results {
        ...MetadataNodeFragment
        isErrorProne
        children {
          ...MetadataNodeFragment
          isErrorProne
          children {
            ...MetadataNodeFragment
            isErrorProne
          }
        }
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default CUISINE_TYPES_QUERY
